// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2xmHQ","paginator":"styles_paginator__1Rr4Y","orderer":"styles_orderer__1w5O3"};